// BOOKING STEPS, PAYMENT PAGE -----

// Import shared
require('./shared')

// Import widgets
require('../../widgets/booking-accommodation-summary/main')
require('../../widgets/booking-awaitable-popup/main')
require('../../widgets/booking-optional-ancillaries-popup/main')
require('../../widgets/booking-back-button/main')
require('../../widgets/booking-basket/main')
require('../../widgets/booking-bundle/main')
require('../../widgets/booking-car-rental/main')
require('../../widgets/booking-choice-list/main')
require('../../widgets/booking-comparison-table/main')
require('../../widgets/booking-generic-summary/main')
require('../../widgets/booking-confirmation-summary/main')
require('../../widgets/booking-coupon-code/main')
require('../../widgets/booking-luggage/main')
require('../../widgets/booking-message/main')
require('../../widgets/booking-error/main')
require('../../widgets/booking-participant-summary/main')
require('../../widgets/booking-participants-badge/main')
require('../../widgets/booking-participants-form/main')
require('../../widgets/booking-price-overview/main')
require('../../widgets/booking-steps-navigation/main')
require('../../widgets/booking-steps-tabs/main')
require('../../widgets/booking-remarks/main')
require('../../widgets/booking-redeemer/main')
require('../../widgets/booking-preferences-selector/main')
require('../../widgets/booking-transport-summary/main')
require('../../widgets/booking-terms-conditions/main')
require('../../widgets/booking-ecommerce-analytics/main')
require('../../widgets/booking-filterable-services/main')
require('../../widgets/payment/main')
require('../../widgets/booking-vouchers/main')
require('../../widgets/booking-usps/main')
require('../../widgets/booking-button-open-page/main')
// This booking-steps widget should be the last to be required
require('../../widgets/booking-steps/main')

require('../../../js/core/widget/widget-api')
